import debtsGraphic from "@/shared/assets/illustrations/debts-2.svg";

import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { CreditCardsReview } from "../components/CreditCardsReview";
import { AddCreditCard } from "../components/AddCreditCard";
import { AddCreditCardManual } from "../components/AddCreditCardManual";

export function createCreditCardScreens(): FlowScreenConfig[] {
  return [
    {
      id: "debts_intro",
      layout: "full",
      imageSrc: debtsGraphic,
      imageSize: "md",
      imagePosition: "right",
      verticalCenter: true,
      sectionLabel: "Section 6",
      maxWidth: "4xl",
      title: "Next, let's document any debts or liabilities",
      subtitle:
        "Together, we'll go through any mortgages, credit cards, or loans. These get paid from the estate first, so this helps us show what your family will inherit.",
      getButtonText: () => "Get started",
    },
    {
      id: "extracted_credit_cards",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: CreditCardsReview,
      shouldDisplay: ({ answers }) =>
        !answers["credit_cards_review"] && answers["extracted_credit_cards"] !== "none",
    },
    {
      id: "add_credit_cards",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: AddCreditCard,
      shouldDisplay: ({ answers }) =>
        answers["extracted_credit_cards"] !== "found" || answers["add_credit_cards"] === "adding",
    },
    {
      id: "add_credit_card_manual",
      layout: "full",
      maxWidth: "4xl",
      hideButton: true,
      skipOnBack: true,
      customComponent: AddCreditCardManual,
      shouldDisplay: ({ answers }) => answers["add_credit_card_manual"] === "active",
    },
    {
      id: "credit_cards_manage",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      hideButton: true,
      customComponent: CreditCardsReview,
      shouldDisplay: ({ answers }) => answers["credit_cards_review"] === "found",
    },
  ];
}
